import '../style.css';

const ErrorResponse = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='error-response'>
    <p>Something Went Wrong!</p>
    <div className='description'>
    We’ve encountered an issue, but we’re here to help!
    <br></br><br/>
    Please contact your Recruiter for a new link to verify your identity.
    </div>
    </div>
            </div>
            </div>
    </div>

    )
};


export default ErrorResponse;